// Toast utility - uses a global toast instance
// This will be initialized by the ToastProvider in App.tsx
let toastInstance: {
  success: (message: string) => void;
  error: (message: string) => void;
  warning: (message: string) => void;
  info: (message: string) => void;
} | null = null;

export const setToastInstance = (instance: {
  success: (message: string) => void;
  error: (message: string) => void;
  warning: (message: string) => void;
  info: (message: string) => void;
}) => {
  toastInstance = instance;
};

export const toast = {
  success: (message: string) => {
    if (toastInstance) {
      toastInstance.success(message);
    } else {
      console.log('Success:', message);
    }
  },
  error: (message: string) => {
    if (toastInstance) {
      toastInstance.error(message);
    } else {
      console.error('Error:', message);
    }
  },
  warning: (message: string) => {
    if (toastInstance) {
      toastInstance.warning(message);
    } else {
      console.warn('Warning:', message);
    }
  },
  info: (message: string) => {
    if (toastInstance) {
      toastInstance.info(message);
    } else {
      console.info('Info:', message);
    }
  },
};
